define('areas/navigationmanager/commands/movenavigationnodecommand',["require", "exports"], function (require, exports) {
    "use strict";
    var MoveNavigationNodeCommand = (function () {
        function MoveNavigationNodeCommand(process) {
            this._moveNode = process;
        }
        MoveNavigationNodeCommand.prototype.execute = function (symbol) {
            this._moveNode.process(symbol);
        };
        return MoveNavigationNodeCommand;
    }());
    return MoveNavigationNodeCommand;
});

